module.exports = require('./helpers/bundle-url').getBundleURL('4Zw3I') + "logo.c51670a8.svg";